import { IUserStatus, UserStatusPriority } from '../../../../models/types';

const SUBJECT_STATE_FRIENDLY_NAMES: Record<string, string> = {
  SubjectStateSos: 'Аварийная ситуация',
  SubjectStateFall: 'Падение с высоты',
  SubjectStateImmobilized: 'Обездвиженность',
  SubjectStatePulseAbnormal: 'Пульс не в норме',
  SubjectStateHazardousTimer: 'Таймер опасности',
  SubjectStateInDangerZone: 'Сотрудник в опасной зоне',
  SubjectStateEmergency: 'Эвакуация',
  SubjectStateAttention: 'Внимание',
  SubjectStateLostContact: 'Потеря связи',
  SubjectStateForgottenProtection: 'Забытое СИЗ',
  SubjectStateProtectionProblem: 'Проблема с СИЗ',
  SubjectStateCharging: 'Трекер заряжается',
  SubjectStateLowCharge: 'Низкий заряд',
  SubjectStateOff: 'Устройство выключено',
  SubjectStateInWork: 'На смене',
  SubjectStatePlacement: 'Местонахождение трекера'
};

const getUserStatuses = (statuses: IUserStatus[], options?: { includeHidden?: boolean }) => {
  if (options?.includeHidden) {
    return statuses;
  }

  return statuses.filter(({ priority }) => priority !== UserStatusPriority.HIDDEN);
};

const getSubjectStateLabel = (state: IUserStatus) =>
  state.ntfy?.classFriendly ||
  (state.systemName && SUBJECT_STATE_FRIENDLY_NAMES[state.systemName]) ||
  state.name ||
  state.systemName ||
  'Состояние';

const getClearStateErrorText = (error: any, fallback: string) => {
  const data = error?.response?.data;
  const detail = typeof data?.detail === 'string' ? data.detail.trim() : '';
  const status = error?.response?.status;
  const typeStr = String(data?.type ?? '').toLowerCase();
  const shouldShowDetail =
    Boolean(detail) && (typeStr.includes('friendly') || status === 400 || status === 500);

  return shouldShowDetail ? `${fallback}: ${detail}` : `${fallback}.`;
};

export { getUserStatuses, getSubjectStateLabel, getClearStateErrorText };
